import {
  getData,
  postData,
  putData,
  editStatusData,
  deleteData,
  getDownloadDataExcel,
} from "../../api";

export const getpackages = async ({ searchName = '', searchMinday = '', searchMaxday = '', featured = "" }) => {
  try {
    return await getData(`/without-login/packages?searchName=${searchName}&searchMinday=${searchMinday}&searchMaxday=${searchMaxday}&featured=${featured}`);
  } catch (error) {
    console.log(error);
  }
};

export const getAllBlog = async (id) => {
  try {
    return await getData(`/without-login/blog/blog-category/${id}`);
  } catch (error) {
    console.log(error);
  }
};

export const getSinglePackage = async (id) => {
  try {
    return await getData(`/without-login/packages/${id}`);
  } catch (error) {
    console.log(error);
  }
};

export const RequestPost = async (data) => {
  try {
    const res = await postData(`/without-login/packages/request`, data);

    return res;
  } catch (error) {
    console.log(error);
  }
};


